import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';

import { FavoritosService } from './../../services/favoritos.service';
import { Material } from './../../models/material.model';
import { MaterialService } from './../../services/material.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  buttonList = {
    backButton: true,
    groupButton: false,
    searchButton: true,
    viewButton: true,
    favButton: true,
    favAllButton: true,
    inFavButton: false,
  }
  toggleView: boolean;
  public material$: Observable<Material[]>;
  public filteredMaterial$: Observable<Material[]>;
  favoritosList;
  search = [];
  filterResult = [];
  filters;
  orderBy = 'Ordenar';
  breadcrumb = '';
  showItems = 20;

  constructor(
    private _route: ActivatedRoute,
    private _location: Location,
    private _toastr: ToastrService,
    private _cookie: CookieService,
    private _material: MaterialService,
    private _favoritos: FavoritosService
  ) {
    const getView = this._cookie.get('focusListView');
    if (getView !== '') {
      this.toggleView = (getView === 'true');
    } else {
      this.toggleView = true;
    }

    const getLabel = this._cookie.get('focusOrderByLabel');
    if (getLabel !== '') {
      this.orderBy = getLabel;
    }
  }

  ngOnInit() {
    this._route.paramMap.subscribe(params => {
      this.search = [decodeURI(params.get('search'))];
    });
    if (this.search[0] != null) {
      this.breadcrumb += this.search;
    } else {
      this._location.back();
    }
    this._route.queryParams.subscribe(params => {
      const setFilter = params['setFilter'];
      if (setFilter == 'descricao') {
        this._cookie.set( 'focusOrderByLabel', 'Descrição', 14, '/' );
        this._cookie.set( 'focusOrderByField', 'MAKTX', 14, '/' );
        this._cookie.set( 'focusOrderByDirection', '-1', 14, '/' );
        this.orderBy = 'Descrição';
      }
    });
    this.meusFavoritos();
    this.material$ = this._material.listMaterial(this.search);
    if(this.orderBy != 'Ordenar') {
      const getField = this._cookie.get('focusOrderByField');
      const getDirection = this._cookie.get('focusOrderByDirection');
      this.material$ = this.orderMaterials(this.material$, getField, getDirection);
    } else {
      this.material$ = this.material$;
    }
    this.filteredMaterial$ = this.material$;
    if (localStorage.getItem('itemLocation') != null) {
      let itemLocation = localStorage.getItem('itemLocation');
      localStorage.removeItem('itemLocation');
      this.goToItemPosition(itemLocation);
    }
  }

  goToItemPosition(itemLocation) {
    const self = this;
    const itemPosition = document.getElementById(itemLocation);
    if (itemPosition != null) {
      window.scroll({ top: itemPosition.offsetTop, left: 0, behavior: 'smooth' });
    } else {
      this.showItems += 20;
      setTimeout(function() {
        self.goToItemPosition(itemLocation);
      }, 100);
    }
  }

  meusFavoritos() {
    this._favoritos.favoritosList.subscribe(list => this.favoritosList = list);
    if (localStorage.getItem("favoritos") === null) {
      this._favoritos.listFav()
        .subscribe(
          (response: any) => {
            localStorage.setItem('favoritos', JSON.stringify(response));
            this.favoritosList = response[0].Itens.map(result => result.MATNR);
          }
        );
    } else {
      this.favoritosList = JSON.parse(localStorage.favoritos)[0].Itens.map(result => result.MATNR);
    }
  }

  trackByFn(index, item) {
    return item.MATNR;
  }

  orderMaterials(materials, field, direction) {
    return materials.pipe(
      map((items:any[]) => {
        items.sort((a: any, b: any) => {
          if (a[field] < b[field]) {
            return direction;
          } else if (a[field] > b[field]) {
            return -direction;
          } else {
            return 0;
          }
        });
        return items;
      })
    );
  }

  filterMaterials(materials,filters) {
    let filterOption = filters.filter(item => item.selected.length > 0);
    let count = 0;
    if (filterOption.length > 0) {
      filterOption.forEach(function(option) {
        materials = materials.pipe(
          map((materials: any[]) => {
            return materials.filter(material => {
              let validate = [];
              option.path.forEach(function(val) {
                if (material[val] != null)
                  validate.push(option.selected.includes(material[val].toLowerCase()));
              });
              return !validate.every(v => !v);
            })
          })
        );
        return materials;
      });
    }
    return materials;
  }

  listenToggleView(status: boolean):void {
    this.toggleView = status;
  }

  orderByOptions(resp) {
    this._cookie.set( 'focusOrderByLabel', resp.label, 14, '/' );
    this._cookie.set( 'focusOrderByField', resp.field, 14, '/' );
    this._cookie.set( 'focusOrderByDirection', resp.direction, 14, '/' );
    this.orderBy = resp.label;
    this.filteredMaterial$ = this.orderMaterials(this.filteredMaterial$, resp.field, resp.direction);
  }

  filterResults(result: any) {
    this.filteredMaterial$ = this.filterMaterials(this.material$,result);
    const field = this._cookie.get( 'focusOrderByField' );
    const direction = this._cookie.get( 'focusOrderByDirection' );
    this.filteredMaterial$ = this.orderMaterials(this.filteredMaterial$, field, direction);
  }

  onScrollDown() {
    this.showItems += 20;
  }

}
